import Cart from '@root/lib/components/Icons/Cart';
import './Catfish.scss';

const Catfish = ({
  onOpen,
  itemCount,
}) => {
  return (
    <div className="Catfish">
      <button className="Catfish__Button" onClick={onOpen}>
        <Cart />
        ({itemCount})
      </button>
    </div>
  );
}

export default Catfish;